import { render, staticRenderFns } from "./MobileAppMenu.vue?vue&type=template&id=019c40eb&"
import script from "./MobileAppMenu.vue?vue&type=script&lang=js&"
export * from "./MobileAppMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports